<div class="flex-1 flex flex-col items-center justify-center p-6 text-center gap-4">
  <div class="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
    <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6 text-red-500"></lucide-icon>
  </div>
  <p class="text-red-600">{{ error() }}</p>
  <button
    type="button"
    (click)="onRetryClick()"
    class="px-5 py-2.5 text-sm font-medium text-white bg-violet-400 rounded-lg hover:bg-violet-500 transition-colors cursor-pointer"
  >
    Try Again
  </button>
</div>
